// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__8PhBx","label":"Radio_label__37ncR","checkMark":"Radio_checkMark__1Auyh","disabled":"Radio_disabled__2S-8i"};